const IranSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111628)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M26.4963 14.7833H23.8795C23.9012 15.0709 23.9134 15.361 23.9134 15.6528C23.9134 17.5875 23.4298 19.4627 22.5868 20.7976C22.3267 21.2093 21.8897 21.7907 21.3047 22.1829V14.7832H18.696V22.1829C18.1111 21.7907 17.674 21.2094 17.4139 20.7976C16.5708 19.4627 16.0873 17.5875 16.0873 15.6528C16.0873 15.361 16.0996 15.0708 16.1212 14.7833H13.5045C13.4877 15.0695 13.4785 15.3593 13.4785 15.6528C13.4785 21.0166 16.3432 25.218 20.0002 25.218C23.6573 25.218 26.522 21.0166 26.522 15.6528C26.5221 15.3593 26.513 15.0695 26.4963 14.7833Z"
        fill="#D80027"
      />
      <path
        d="M8.2607 9.56523H10.8694V11.3044H13.478V9.56523H16.0867V11.3044H18.6954V9.56523H21.3041V11.3044H23.9127V9.56523H26.5214V11.3044H29.1301V9.56523H31.7388V11.3044H38.0151C34.7803 4.61445 27.929 0 19.9998 0C12.0707 0 5.21938 4.61445 1.98438 11.3044H8.2607V9.56523Z"
        fill="#6DA544"
      />
      <path
        d="M31.739 28.6953V30.4345H29.1303V28.6953H26.5216V30.4345H23.913V28.6953H21.3043V30.4345H18.6956V28.6953H16.087V30.4345H13.4783V28.6953H10.8694V30.4345H8.2607V28.6953H1.98438C5.21938 35.3852 12.0706 39.9997 19.9998 39.9997C27.9291 39.9997 34.7803 35.3852 38.0153 28.6953H31.739Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111628">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default IranSvg;
